var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("This is the single entity component\n\t"),(_vm.entity)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.entity.displayName()))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.entity))])]):_c('div',[_vm._v("Nae entity ☹")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5436356a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Entity.vue
// module id = null
// module chunks = 